import { GameCardConfiguration } from '../../gamesConfiguration';
import { step10statue } from './steps/10-statue';
import { step11statue } from './steps/11-statue';
import { step12park } from './steps/12-park';
import { step14park } from './steps/14-park';
import { step15color } from './steps/15-color';
import { step16cones } from './steps/16-cones';
import { step17fences } from './steps/17-fences';
import { step18castle } from './steps/18-castle';
import { step19crossroads } from './steps/19-crossroads';
import { step1intro } from './steps/1-intro';
import { step20crossroads } from './steps/20-crossroads';
import { step21crossroads } from './steps/21-crossroads';
import { step22pipe } from './steps/22-pipe';
import { step24trees } from './steps/24-trees';
import { step25mosaic } from './steps/25-mosaic';
import { step26butchers } from './steps/26-butchers';
import { step27butchers } from './steps/27-butchers';
import { step28butchers } from './steps/28-butchers';
import { step29paths } from './steps/29-paths';
import { step2dolphin } from './steps/2-dolphin';
import { step30dog } from './steps/30-dog';
import { step31king } from './steps/31-king';
import { step32statue } from './steps/32-statue';
import { step33statue } from './steps/33-statue';
import { step34library } from './steps/34-library';
import { step35graveyard } from './steps/35-graveyard';
import { step36graveyard } from './steps/36-graveyard';
import { step37graveyard } from './steps/37-graveyard';
import { step38museum } from './steps/38-museum';
import { step39end } from './steps/39-end';
import { step3well } from './steps/3-well';
import { step4cafe } from './steps/4-cafe';
import { step5bird } from './steps/5-bird';
import { step6falconry } from './steps/6-falconry';
import { step7falconry } from './steps/7-falconry';
import { step8house } from './steps/8-house';
import { step9house } from './steps/9-house';
import gameBackground from '../../../assets/images/games/zdar-escape-game/game-preview.webp';

export const zdarEscapeGameNumberSteps = [9, 13, 17, 28, 30, 33];
export const zdarEscapeGameContentConfiguration: ZdarGameConfiguration = {
    cardConfiguration: {
        title: 'Ztracený poklad Žďáru',
        subtitle: 'Městská únikovka',
        background: gameBackground,
        gameUrl: '/mestska-unikovka-zdar',
        showValidity: true,
    },
    gameConfiguration: [
        { id: 0 },
        step1intro,
        step2dolphin,
        step3well,
        step4cafe,
        step5bird,
        step6falconry,
        step7falconry,
        step8house,
        step9house,
        step10statue,
        step11statue,
        step12park,
        step14park,
        step15color,
        step16cones,
        step17fences,
        step18castle,
        step19crossroads,
        step20crossroads,
        step21crossroads,
        step22pipe,
        step24trees,
        step25mosaic,
        step26butchers,
        step27butchers,
        step28butchers,
        step29paths,
        step30dog,
        step31king,
        step32statue,
        step33statue,
        step34library,
        step35graveyard,
        step36graveyard,
        step37graveyard,
        step38museum,
        step39end,
    ],
};

export type ZdarGameCipher = {
    text?: string;
    images?: any[];
    isPathFinder?: boolean;
    custom?: any;
    snowImages?: any[];
    snowSelectionText?: string;
    label?: string;
};

export type ZdarGameHint = {
    text?: string;
    image?: any;
    html?: string;
    solution?: boolean;
};

export type ZdarGameStepConfiguration = {
    id: number;
    title?: string;
    taskText?: string;
    taskText2?: string;
    snowTaskText?: string;
    catImage?: number;
    taskPreviewText?: string;
    audio?: any;
    snowAudio?: any;
    codeInputText?: string;
    codeInputPassCodeRegexp?: string;
    additionalInfo?: string;
    hints?: ZdarGameHint[];
    snowHints?: ZdarGameHint[];
    cipher?: ZdarGameCipher;
    snowCipher?: ZdarGameCipher;
    continueButtonText?: string;
    codeInputPassCodeCommonMistakeRegexp?: [string];
    codeInputPassCodeCommonMistakeMessage?: [string];
    coatTexts?: string[];
    coatImages?: any[];
};

export type ZdarGameGameConfiguration = ZdarGameStepConfiguration[];

export type ZdarGameConfiguration = {
    cardConfiguration: GameCardConfiguration;
    gameConfiguration: ZdarGameGameConfiguration;
};
